import { AppShell, Container, useMantineTheme } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Outlet } from "react-router-dom";

export function PrimaryMobileLayout() {
  const [_opened, { toggle, close }] = useDisclosure();
  const theme = useMantineTheme();

  return (
    <AppShell>
      <Container
        size="xs"
        p={0}
        style={{
          backgroundColor: theme.black,
          height: "100dvh",
          overflowY: "auto",
        }}
      >
        <AppShell.Main
          id="primary-mobile-layout-main"
          style={{
            backgroundColor: theme.black,
            height: "100%",
            position: "relative",
          }}
        >
          <Outlet />
        </AppShell.Main>
      </Container>
    </AppShell>
  );
}
